export default "__VITE_ASSET__81aaa641__"